import React, { Component } from "react";

import WidgetAjax from "../../widget/WidgetAjax";
import Config from "../../config/Config";
import './../../css/frame.css';
import './../../css/project.css';
import './index.scss';

class Index extends Component {

    constructor(props) 
    {
        super(props);

        this.state = {
            pageList: []
        }
    }
    componentDidMount(){
        this.queryAuditList();
    }
    queryAuditList(){
        WidgetAjax.ajax({
            url : Config.getBasePath()+'/entsq/audit_list', 
            params : {
                SQID: this.props.location.state.SQID,
                INFO: 'INFO',
            }, 
            callback : (data)=>{
                if(data&&data.status === 0){
                    data.results.forEach(da => {
                        if(da.HJMC==='县审核'){
                            da.HJMC = '待审核'
                        }else if(da.HJMC==='县报送'){
                            da.HJMC = '待审核'
                        }else if(da.HJMC==='县审核驳回'){
                            da.HJMC = '驳回'
                        }else if(da.HJMC==='县审核退回'){
                            da.HJMC = '退回'
                        }else if(da.HJMC==='市报送'){
                            da.HJMC = '待审核'
                        }else if(da.HJMC==='市报送退回'){
                            da.HJMC = '退回'
                        }else if(da.HJMC==='市报送驳回'){
                            da.HJMC = '驳回'
                        }else if(da.HJMC==='市审核驳回'){
                            da.HJMC = '驳回'
                        }else if(da.HJMC==='省审核'){
                            da.HJMC = '待审核'
                        }else if(da.HJMC==='省报送驳回'){
                            da.HJMC = '驳回'
                        }else if(da.HJMC==='总局'){
                            da.HJMC = '认定入库'
                        }else{
                            da.HJMC = da.HJMC
                        }
                        da.BLJG = da.BLJG.replace('市报送退回','退回').replace('县审核驳回','驳回').replace('县审核退回','退回').replace('省审核通过','认定入库').replace('市报送通过','待审核').replace('待审核通过','待审核').replace('市报送驳回','驳回').replace('省审核驳回','驳回').replace('省报送驳回','驳回').replace('县报送通过','待审核').replace('市审核退回','退回').replace('市审核驳回','驳回')
                    });
                    this.setState({
                        pageList: data.results
                    })
                }
            }
        },this);
    }
    onChange(value) {
        console.log(value);
    };
    goPage(){
        window.history.go(-1);
    }
    render()
    {
        const { pageList } = this.state;
        return (
            <div data-component="notice">
                <div className="sg-login-top sd-start">
                    <div onClick={()=>{this.goPage()}} className="sd-start">
                        <img className='sg-information-img' alt='#' src={require('../../img/business/upPage.png')}/>
                        <span className="sg-top-font" style={{color:'#357AC5'}}>返回</span>
                    </div>
                </div>
                <div className="sg-notice">
                    <div className="sg-notice-center">
                        <div className="sg-center-top sd-start">
                            <span className="sg-center-font">申报通知</span>
                        </div>
                        <div className="sg-center-middle sd-columnCenter">
                            <div className="sg-middle-list" style={{display:pageList&&pageList.length?'block':'none'}}>
                                {
                                    pageList&&pageList.map((res,i)=>{
                                        let year = new Date(res.BLSJ).getFullYear()
                                        // return <div className="sg-list-li">{i+1}. 您{year}年度第一批申报{res.BLJG==='通过'?res.HJMC:''}{res.BLJG}{res.BLJG.indexOf('通过')===-1?',原因：':''}{res.BLJG.indexOf('通过')===-1?res.BLYJ:''}。</div>
                                        return <div className="sg-list-li">{i+1}. 您{res?.ND}年度第一批申报{res.BLJG==='通过'?res.HJMC:''}{res.BLJG}。</div>
                                    })
                                }
                            </div>
                            <div className="sd-columnCenter" style={{display:pageList&&pageList.length?'none':'flex'}}>
                                <img className='sg-middle-img' alt='#' src={require('../../img/business/defined.png')} />
                                <div className="sg-middle-font">暂无申报通知！</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Index
